module.exports = __webpack_public_path__ + "68a587ff2b3154d92d86fca85ddf4974.svg";